/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WriteOnlyWhiteLabelTemplate
 */
export interface WriteOnlyWhiteLabelTemplate {
    /**
     * 
     * @type {string}
     * @memberof WriteOnlyWhiteLabelTemplate
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof WriteOnlyWhiteLabelTemplate
     */
    name?: string | null;
    /**
     * 
     * @type {object}
     * @memberof WriteOnlyWhiteLabelTemplate
     */
    content: object;
    /**
     * 
     * @type {number}
     * @memberof WriteOnlyWhiteLabelTemplate
     */
    client?: number | null;
}

export function WriteOnlyWhiteLabelTemplateFromJSON(json: any): WriteOnlyWhiteLabelTemplate {
    return WriteOnlyWhiteLabelTemplateFromJSONTyped(json, false);
}

export function WriteOnlyWhiteLabelTemplateFromJSONTyped(json: any, ignoreDiscriminator: boolean): WriteOnlyWhiteLabelTemplate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'content': json['content'],
        'client': !exists(json, 'client') ? undefined : json['client'],
    };
}

export function WriteOnlyWhiteLabelTemplateToJSON(value?: WriteOnlyWhiteLabelTemplate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'content': value.content,
        'client': value.client,
    };
}


